export default "__VITE_PUBLIC_ASSET__9300e545__"